import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { setupAgGrid } from "./config/agGrid";

setupAgGrid();

createRoot(document.getElementById("root")!).render(<App />);
